import angular from 'angular';
import contactRoutingModule from './contact-routing-module';
import contactListModule from './components/contact-list/contact-list-module';
import inquiryContactListModule from './components/inquiry-contacts-list/inquiry-contacts-list-module';
import contactUsModule from './components/contact-us/contact-us-module';
import manageContactModule from './components/manage-contact/manage-contact-module';

export default angular.module('contact', [
  contactRoutingModule.name,
  contactListModule.name,
  inquiryContactListModule.name,
  contactUsModule.name,
  manageContactModule.name,
]);



// WEBPACK FOOTER //
// ./src/modules/contact/contact-module.js